import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "12"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M13.482 3.093a2.593 2.593 0 0 1-5.067.777H.778a.778.778 0 0 1 0-1.555h7.637a2.594 2.594 0 0 1 5.067.778M10.889 4.13a1.037 1.037 0 1 0 0-2.074 1.037 1.037 0 0 0 0 2.074m-8.296 7.683c1.16 0 2.143-.763 2.474-1.815h8.155a.778.778 0 1 0 0-1.555H5.067a2.594 2.594 0 1 0-2.474 3.37m0-1.555a1.037 1.037 0 1 0 0-2.074 1.037 1.037 0 0 0 0 2.074",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }